import { Box } from '@mui/material';
import FontAwesomeSvgIcon from 'components/shared/FontAwesomeSvgIcon';
import { t } from 'i18next';
import { faInbox } from 'vendors/@fortawesome/pro-light-svg-icons';

const TaskListAllDone = () => {
  return (
    <Box
      paddingY={2}
      fontSize={14}
      fontStyle="italic"
      display="flex"
      flexDirection="column"
      gap={1}
      justifyContent="center"
      alignItems="center"
      width={1}
    >
      <FontAwesomeSvgIcon icon={faInbox} color="primary" fontSize="medium" />
      {t('taskList.taskDone')}
    </Box>
  );
};

export default TaskListAllDone;
